module.exports = __webpack_public_path__ + "img/logo.93fa92c2.png";